const newVendorInfo = (function () {

    let vendorID;
    let ispDiv;
    let ispNav;
    let ispBody;
    let DDNumber;
    let LocalNumber;
    let Phone;
    let Name;
    let tabPositionIndex;
    let ADD_BTN;

    const sections = [
        {
            title: 'General',
            id: 0,
            markup: () => vendorGeneral.getMarkup(),
        },
        {
            title: 'Services',
            id: 1,
            markup: () => vendorServices.getMarkup(),
        },
        {
            title: 'UCR',
            id: 2,
            markup: () => vendorUCR.getMarkup(),
        },
        {
            title: 'Provider Type',
            id: 3,
            markup: () => vendorProviderType.getMarkup(),
        },
        {
            title: 'Certification',
            id: 4,
            markup: () => vendorCertification.getMarkup(),
        },
        {
            title: 'Location Reviews',
            id: 5,
            markup: () => vendorLocationReview.getMarkup(),
        },
        {
            title: 'Attachments',
            id: 6,   
            markup: () => vendorAttachments.getMarkup(),
        },

    ];

    async function refreshVendor(vendorId, DDNum, localNum, phone, name, TabPosition = 0) {
        vendorID = vendorId;
        DDNumber = DDNum;
        LocalNumber = localNum;
        Phone = phone;
        Name = name;
        tabPositionIndex = TabPosition;
        DOM.clearActionCenter();

        var headingWrap = document.createElement('div');
        headingWrap.classList.add('vendorBtnWrap');        
        const heading = document.createElement('div');
        const headingName = document.createElement('div');
        const localNumberheading = document.createElement('div');
        const head = document.createElement('div');

        const ispWrap = document.createElement('div');

        ispWrap.id = 'planISP';

        ispWrap.innerHTML = '';

        BACK_BTN = button.build({
            text: 'BACK',
            style: 'secondary',
            type: 'outlined',
            callback: async () => { await vendorInfo.vendorInfoLoad() }, 
        });

        ADD_BTN = button.build({
            text: '',
            style: 'secondary',
            type: 'contained',
            classNames:'hidden',
            callback: async () => {
                let sectionId = ADD_BTN.getAttribute('sectionId');
                switch (sectionId) {
                    //case '2':
                    //    if ($.session.authorizationInsertVendorInfo) {
                    //        vendorUCR.showUCRPopup();
                    //    }
                    //    break;
                    case '3':
                        if ($.session.authorizationInsertVendorInfo) {
                            vendorProviderType.showNewProviderTypePopup();
                        }
                        break;
                    case '4':
                        if ($.session.authorizationInsertVendorInfo) {
                            vendorCertification.showNewCertificationPopup();
                        }
                        break;
                    case '5':
                        if ($.session.authorizationInsertVendorInfo) {
                            vendorLocationReview.showLocationReviewPopup();
                        }
                        break;
                    case '6':
                        if ($.session.authorizationsVendorInfoUpdate) {
                            vendorAttachments.showNewAttachmentForm();
                        }
                        break;
                }
            },
        });
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('vendorInfoBtnWrap');
        btnWrap.appendChild(ADD_BTN);
        btnWrap.appendChild(BACK_BTN);

        const newIspMarkup = await getMarkup();

        if (Name && Name !== '') {
            heading.innerHTML = `<h4>${Name} ${Phone}</h4>`;
        }
        if (DDNumber && DDNumber !== '') {
            headingName.innerHTML = `<h4>DD Number: ${DDNumber} </h4>`;
        }
        if (LocalNumber && LocalNumber !== '') {
            localNumberheading.innerHTML = `<h4>Local Number: ${LocalNumber}</h4>`;
        }
        ispWrap.appendChild(newIspMarkup);

        head.appendChild(heading);
        head.appendChild(headingName);
        head.appendChild(localNumberheading);
        headingWrap.appendChild(head);
        headingWrap.appendChild(btnWrap);       

        DOM.ACTIONCENTER.appendChild(headingWrap);
        DOM.ACTIONCENTER.appendChild(ispWrap);
        DOM.autosizeTextarea();
        toggleActiveSection(tabPositionIndex);
    }
    function toggleActiveNavItem(selectedNavItem) {
        const activeNavItem = ispNav.querySelector('.active');

        if (activeNavItem) {
            activeNavItem.classList.remove('active');
        }

        selectedNavItem.classList.add('active');
    }
    function toggleActiveSection(sectionId) {
        ADD_BTN.classList.add('hidden');
        ADD_BTN.setAttribute('sectionId', sectionId);
        const activeSection = ispBody.querySelector('.active');
        const targetSection = ispBody.querySelector(`[data-section-id="${sectionId}"]`);

        if (activeSection) {
            activeSection.classList.remove('active');
        }

        targetSection.classList.add('active');        
        switch (sectionId) {
            //case 2:
            //    if ($.session.authorizationInsertVendorInfo) {
            //        ADD_BTN.classList.remove('hidden');
            //        ADD_BTN.textContent = 'Add UCR';
            //    }
            //    break;
            case 3:
                if ($.session.authorizationInsertVendorInfo) {
                    ADD_BTN.classList.remove('hidden');
                    ADD_BTN.textContent = 'Add Provider Type';
                }
                break;
            case 4:
                if ($.session.authorizationInsertVendorInfo) {
                    ADD_BTN.classList.remove('hidden');
                    ADD_BTN.textContent = 'Add Certification';
                }
                break;
            case 5:
                if ($.session.authorizationInsertVendorInfo) {
                    ADD_BTN.classList.remove('hidden');
                    ADD_BTN.textContent = 'Add Location Review';
                }
                break;
            case 6:
                if ($.session.authorizationsVendorInfoUpdate) {
                    ADD_BTN.classList.remove('hidden');
                    ADD_BTN.textContent = 'Add Attachment';
                }                            
                break;
        }
    }

    // Markup
    //---------------------------------------------
    function buildNavigation() {
        const nav = document.createElement('div');
        nav.classList.add('planISP__nav');

        sections.forEach((section, index) => {
            const sectionId = section.id;

            const navItem = document.createElement('div');
            navItem.classList.add('planISP__navItem');
            navItem.innerHTML = `${section.title}`;

            if (tabPositionIndex === index) {
                navItem.classList.add('active');
            }

            if (vendorID === 0 && sectionId > 0) {
                navItem.classList.add('disabled');
            }

            navItem.addEventListener('click', e => {
                toggleActiveNavItem(navItem);
                toggleActiveSection(sectionId);
                DOM.autosizeTextarea();
            });

            nav.appendChild(navItem);
        });

        return nav;
    }
    async function buildBody() {
        const body = document.createElement('div');
        body.classList.add('planISP__body');

        await vendorGeneral.init(vendorID);
        await vendorServices.init(vendorID);
        await vendorUCR.init(vendorID);
        await vendorProviderType.init(vendorID);
        await vendorCertification.init(vendorID);
        await vendorLocationReview.init(vendorID);
        await vendorAttachments.init(vendorID, DDNumber, LocalNumber, Phone, Name); 

        sections.forEach((section, index) => {
            const sectionId = section.id;
            const sectionMarkup = section.markup();
            sectionMarkup.setAttribute('data-section-id', sectionId);
            sectionMarkup.classList.add('planISP__section');

            if (tabPositionIndex === index) { 
                sectionMarkup.classList.add('active');
            }

            body.appendChild(sectionMarkup);
        });

        return body;
    }

    async function getMarkup() {
        ispDiv = document.createElement('div');
        ispDiv.classList.add('planISP');

        ispNav = buildNavigation();
        ispDiv.appendChild(ispNav);

        ispBody = await buildBody();
        ispDiv.appendChild(ispBody);

        return ispDiv;
    }

    return {
        refreshVendor,
        getMarkup,
    };
})();
